import React from 'react';
import { createPortal } from 'react-dom';
import { withTranslation } from 'react-i18next';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from 'ui-connect';

import Translate from 'components/Translate';

/**
 *
 * @param {{
 *  open: boolean;
 *  onClose: () => any;
 * }} props
 * @returns
 */
const CommentReachedLimitDialog = (props) => {
    return createPortal(
        <Dialog key={props.key} open={props.open} onClose={props.onClose}>
            <DialogTitle>
                <Translate ns="news_feed" content="comment_limit_reached_title" />
            </DialogTitle>
            <DialogContent>
                <Translate ns="news_feed" content="comment_limit_reached_desc" />
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose}>
                    <Translate ns="common" content="button_ok" />
                </Button>
            </DialogActions>
        </Dialog>,
        document.querySelector('.connect-container')
    );
};

export default withTranslation(['news_feed', 'common'])(CommentReachedLimitDialog);
